import { Epic } from 'redux-observable';
import { of, from, timer } from 'rxjs';
import { mergeMap, map, catchError, filter, switchMap, takeWhile } from 'rxjs/operators';
import { RootState } from '../store';
import {
  renewalUploadRequested,
  renewalUploadSucceeded,
  renewalUploadFailed,
  renewalStatusSucceeded,
  renewalStatusFailed
} from '../slices/renewalNoticeUploadSlice';
import {
  uploadRenewalNoticeData,
  getRenewalNoticeUploadStatus
} from '@/services/api';

// Start upload epic
export const startRenewalUploadEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === renewalUploadRequested.type),
    mergeMap((action: any) => {
      const { file, truncate } = action.payload;
      return from(uploadRenewalNoticeData(file, !!truncate)).pipe(
        map((response) => renewalUploadSucceeded(response)),
        catchError((error) => of(renewalUploadFailed(error.message || 'Failed to upload renewal notice data')))
      );
    })
  );

// Polling status epic: after succeeded, poll status until completed/failed
export const pollRenewalUploadStatusEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action: any) => action.type === renewalUploadSucceeded.type),
    switchMap((action: any) => {
      const taskId = action.payload.task_id;
      // Poll every 2 seconds
      return timer(0, 2000).pipe(
        switchMap(() => from(getRenewalNoticeUploadStatus(taskId)).pipe(
          map((statusResp) => {
            return renewalStatusSucceeded({
              status: statusResp.status as any,
              progress: statusResp.progress,
              total_rows: statusResp.total_rows,
              processed_rows: statusResp.processed_rows,
              successful_rows: statusResp.successful_rows,
              failed_rows: statusResp.failed_rows,
              errors: Array.isArray(statusResp.errors) ? (statusResp.errors as any) : []
            });
          }),
          catchError((error) => of(renewalStatusFailed(error.message || 'Failed to get upload status')))
        )),
        takeWhile((action: any) => {
          // Keep polling while status is pending/processing
          if (!action || !action.payload) return true;
          const s = action.payload.status;
          return s === 'pending' || s === 'processing';
        }, true)
      );
    })
  );

export default [startRenewalUploadEpic, pollRenewalUploadStatusEpic];



